module.exports = __webpack_public_path__ + "img/17.f59770ea.png";